type Status = 'ok' | 'warn' | 'critical' | 'offline'

interface StatusDotProps {
  status: Status
  className?: string
}

const dotStyles: Record<Status, string> = {
  ok: 'bg-[rgb(var(--np-status-ok))] shadow-[0_0_6px_rgb(var(--np-status-ok)/0.5)]',
  warn: 'bg-[rgb(var(--np-status-warn))] shadow-[0_0_6px_rgb(var(--np-status-warn)/0.5)]',
  critical: 'bg-[rgb(var(--np-status-critical))] shadow-[0_0_6px_rgb(var(--np-status-critical)/0.5)] animate-pulse-subtle',
  offline: 'bg-[rgb(var(--np-tx-muted))]',
}

export function StatusDot({ status, className = '' }: StatusDotProps) {
  return (
    <span
      className={`inline-block w-2 h-2 rounded-full ${dotStyles[status]} ${className}`}
    />
  )
}
